// extracted by mini-css-extract-plugin
export default {"groupInformationHeader":"MediaGroupDetailsView_groupInformationHeader__Re8g5","groupInformationContainer":"MediaGroupDetailsView_groupInformationContainer__XbFrZ"};